import React, { useState } from "react";
import { C } from "../theme";
import { fmt, fmtD, Tag, Kpi, Btn, Inp, Sel } from "../shared";

export const ChargesPage = ({ charges, setCharges, immId }) => {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({description:"",montant:"",date:"",cat:"Entretien",fournisseur:""});
  const list = charges.filter(c => c.immId === immId);
  const save = () => {
    setCharges(p => [...p, {id:Date.now(), immId, ...form, montant:Number(form.montant), justif:false}]);
    setModal(false);
    setForm({description:"",montant:"",date:"",cat:"Entretien",fournisseur:""});
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div><h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Charges & Dépenses</h2><p style={{color:C.muted,fontSize:13}}>Total : {fmt(list.reduce((a,c)=>a+c.montant,0))}</p></div>
        <Btn onClick={() => setModal(true)}>+ Nouvelle charge</Btn>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
        {["Entretien","Réparations","Assurance","Services"].map((cat, i) => (
          <Kpi key={cat} icon={["🧹","🔧","🛡️","👷"][i]} label={cat}
            value={fmt(list.filter(c=>c.cat===cat).reduce((a,c)=>a+c.montant,0))}
            color={[C.blue,C.green,C.gold,C.orange][i]} delay={i*60} />
        ))}
      </div>
      <div className="fu" style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
        <table>
          <thead><tr><th>Description</th><th>Fournisseur</th><th>Catégorie</th><th>Date</th><th>Montant</th><th>Justif.</th><th></th></tr></thead>
          <tbody>
            {list.map(c => (
              <tr key={c.id}>
                <td style={{fontWeight:600}}>{c.description}</td>
                <td style={{color:C.muted}}>{c.fournisseur}</td>
                <td><span style={{background:C.blueL,color:C.blue,padding:"2px 9px",borderRadius:8,fontSize:11,fontWeight:600}}>{c.cat}</span></td>
                <td style={{color:C.muted}}>{fmtD(c.date)}</td>
                <td style={{fontWeight:700}}>{fmt(c.montant)}</td>
                <td>{c.justif ? "✅" : <span style={{color:C.muted,fontSize:12}}>Non</span>}</td>
                <td><button onClick={() => setCharges(p=>p.filter(x=>x.id!==c.id))} style={{background:"none",border:"none",cursor:"pointer",color:C.muted,fontSize:17}}>🗑️</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {modal && (
        <div className="ov" onClick={() => setModal(false)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:19,fontWeight:800,color:C.text,marginBottom:20}}>Nouvelle dépense</h3>
            <Inp label="Description" value={form.description} onChange={v => setForm({...form,description:v})} />
            <Inp label="Fournisseur" value={form.fournisseur} onChange={v => setForm({...form,fournisseur:v})} />
            <Inp label="Montant (MAD)" type="number" value={form.montant} onChange={v => setForm({...form,montant:v})} />
            <Inp label="Date" type="date" value={form.date} onChange={v => setForm({...form,date:v})} />
            <Sel label="Catégorie" value={form.cat} onChange={v => setForm({...form,cat:v})} options={["Entretien","Réparations","Assurance","Services","Autres"]} />
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
              <Btn onClick={() => setModal(false)} outline>Annuler</Btn>
              <Btn onClick={save}>Enregistrer</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — TRAVAUX
══════════════════════════════════════ */
